import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { API_URLS } from '../config/api';
import { apiPost } from '../utils/apiUtils';
import { t } from '../i18n';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!password || !confirm) {
      setError(t('Пожалуйста, заполните оба поля.'));
      return;
    }
    if (password !== confirm) {
      setError(t('Пароли не совпадают.'));
      return;
    }
    if (password.length < 6) {
      setError(t('Пароль должен содержать минимум 6 символов.'));
      return;
    }

    setLoading(true);
    try {
      await apiPost(API_URLS.RESET_PASSWORD, { token, new_password: password }, {}, false);
      setDone(true);
    } catch (err) {
      setError(err.message || t('Не удалось сбросить пароль.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {done ? (
          <>
            <div style={styles.icon}>✅</div>
            <h2 style={styles.title}>{t('Пароль изменён!')}</h2>
            <p style={styles.text}>{t('Теперь вы можете войти с новым паролем.')}</p>
            <Link to="/" style={styles.btn}>{t('Войти')}</Link>
          </>
        ) : (
          <>
            <h2 style={styles.title}>{t('Новый пароль')}</h2>
            <p style={styles.text}>{t('Введите новый пароль для вашего аккаунта.')}</p>

            {!token && (
              <p style={{ color: '#f87171', margin: 0, fontSize: '0.95rem' }}>
                {t('Ссылка недействительна. Запросите новую.')}
              </p>
            )}

            {token && (
              <form onSubmit={handleSubmit} style={styles.form}>
                {error && <p style={styles.errorText}>{error}</p>}
                <input
                  style={styles.input}
                  type="password"
                  placeholder={t('Новый пароль')}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                  autoComplete="new-password"
                />
                <input
                  style={styles.input}
                  type="password"
                  placeholder={t('Подтвердить пароль')}
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  disabled={loading}
                  autoComplete="new-password"
                />
                <button type="submit" style={styles.btn} disabled={loading}>
                  {loading ? t('Сохранение…') : t('Сохранить пароль')}
                </button>
              </form>
            )}

            <Link to="/" style={styles.backLink}>← {t('На главную')}</Link>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0a0a0f',
    fontFamily: "'Alegreya Sans', sans-serif",
    padding: '2rem',
  },
  card: {
    background: '#16161f',
    border: '1px solid #2a2a3a',
    borderRadius: '16px',
    padding: '2.5rem',
    maxWidth: '420px',
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
  },
  icon: { fontSize: '3rem' },
  title: { color: '#e8e8f0', margin: 0, fontSize: '1.5rem' },
  text: { color: '#9090a8', margin: 0, fontSize: '1rem', lineHeight: 1.6 },
  form: { display: 'flex', flexDirection: 'column', gap: '0.75rem', width: '100%' },
  input: {
    background: '#0e0e18',
    border: '1px solid #2a2a3a',
    borderRadius: '8px',
    color: '#e8e8f0',
    padding: '0.75rem 1rem',
    fontSize: '1rem',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  btn: {
    display: 'inline-block',
    padding: '0.75rem 2rem',
    background: '#7c3aed',
    color: '#fff',
    borderRadius: '8px',
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    border: 'none',
    cursor: 'pointer',
    width: '100%',
  },
  backLink: { color: '#9090a8', fontSize: '0.9rem', textDecoration: 'none' },
  errorText: { color: '#f87171', margin: 0, fontSize: '0.95rem' },
};

export default ResetPasswordPage;
